import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { isEqual } from 'lodash'
import { featureFlagsDict } from 'utils/featureFlagsDict'

// Define the type for the initial state
interface FeatureFlagsState {
  treatments: SplitIO.TreatmentsWithConfig | Record<string, never>
  variables: Record<string, boolean>
}

interface FeatureFlagOverride {
  splitName: keyof typeof featureFlagsDict
  treatmentOverride: 'on' | 'off'
}

const initialState: FeatureFlagsState = {
  treatments: {},
  variables: {},
}

export const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setFeatureFlags: (state, action: PayloadAction<SplitIO.TreatmentsWithConfig>) => {
      if (isEqual(action.payload, state.treatments)) return
      const newVariables = {}
      Object.entries(action.payload || {}).forEach(([splitName, treatmentData]) => {
        const variableName = featureFlagsDict[splitName]
        newVariables[variableName] = treatmentData?.treatment === 'on'
      })
      state.variables = newVariables
      state.treatments = action.payload
    },
    overrideFeatureFlag: (state, action: PayloadAction<FeatureFlagOverride>) => {
      const { splitName, treatmentOverride = 'on' } = action.payload
      if (!splitName) return
      state.treatments[splitName as string] = { treatment: treatmentOverride, config: '' }
      const variableName = featureFlagsDict[splitName]
      state.variables[variableName] = treatmentOverride === 'on'
    },
  },
})

export const { setFeatureFlags, overrideFeatureFlag } = featureFlagsSlice.actions

export default featureFlagsSlice.reducer
